export default __webpack_public_path__ + "9fb2d834cc3df6d0951538d8a6fe6e8f.svg";